export const HYPERWALLET_LEGAL_LINK =
  'https://pay.hyperwallet.com/hw2web/consumer/page/legalAgreement.xhtml'
